import { useContext, useEffect, useState } from "react"
import { toast } from "react-toastify"
import { Table } from "reactstrap"
import { Link, useNavigate } from "react-router-dom"

import { confirm } from "components/Confirmation"
import IconButton from "components/IconButton"
import ModalVideo from "components/ModalVideo"

import AppContext from "AppContext"
import cameraService from "services/CameraService"

export default function Cameras({ edit, idCruzamento }) {
  const [items, setItems] = useState([])
  const [configModalVideo, setConfigModalVideo] = useState(null)
  const { state } = useContext(AppContext)
  const navigate = useNavigate()

  const carregar = async () => {
    const res = await cameraService.get(idCruzamento)
    if (res.success) {
      setItems(res.data)
    }
  }

  useEffect(() => {
    if (idCruzamento) {
      carregar()
    }
  }, [idCruzamento])

  const handleDelete = (item) => {
    confirm({
      header: "Exclusão",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          const res = await cameraService.delete(item.id)
          if (res.success) {
            carregar()
            toast("Câmera excluída")
          } else {
            toast("Erro ao excluir a câmera")
          }
        } catch (ex) {
          toast("Erro ao excluir a câmera")
        }
      }
    })
  }

  return (
    <>
      {edit && (
        <div className="d-flex flex-row justify-content-end align-items-center pb-4">
          <Link className="btn btn-primary btn-icon" to={`/admin/cruzamentos/${idCruzamento}/cameras/0`}>Incluir</Link>
        </div>
      )}

      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col">Código</th>
            <th scope="col" style={{ width: 60 }}></th>
          </tr>
        </thead>
        <tbody>
          {items.length == 0 && (
            <tr>
              <td colSpan={2} className="text-center">Nenhum registro</td>
            </tr>
          )}
          {items.map(el => (
            <tr key={el.id}>
              <td>{el.codigo}</td>
              <td className="d-flex flex-row gap-5px">
                <IconButton alt="Visualizar" iconClass="bi-camera" onClick={() => setConfigModalVideo({ videoUrl: el.url, descricao: `Câmera ${el.codigo}` })} />
                <IconButton alt="Editar" iconClass="bi-pencil-square" onClick={() => navigate("/admin/cruzamentos/" + idCruzamento + '/cameras/' + el.id)} />
                {edit && (
                  <IconButton alt="Excluir" iconClass="bi-trash" onClick={() => handleDelete(el)} />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <ModalVideo config={configModalVideo} onClose={() => setConfigModalVideo(null)} />
    </>
  )
}